import { render, staticRenderFns } from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=template&id=2aa8dbf2"
import script from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports